var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBook28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.196 3.103a.5.5 0 0 1 .436-.085L13.5 5.982l10.868-2.964A.5.5 0 0 1 25 3.5v15a.5.5 0 0 1-.368.482l-10.99 2.997a.506.506 0 0 1-.285 0L2.368 18.982A.5.5 0 0 1 2 18.5v-15a.5.5 0 0 1 .196-.397ZM24 18.118l-10 2.727V6.882l10-2.727v13.963ZM3 4.155l10 2.727v13.963L3 18.118V4.155ZM3 22.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 .5.5h22a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0V24H3v-1.5Z",
  clipRule: "evenodd"
})));
export { SvgBook28 as ReactComponent };
export default __webpack_public_path__ + "88ce94746560ec1e6bbbfa6e09e9df3a.svg";